const { createTheme } = require('@mui/material');

export const customDialogImportTheme = createTheme({
  components: {
    MuiDialog: {
      styleOverrides: {
        root: {
          // shape of the modal
          '& .MuiDialog-paper': {
            border: '3px solid #e69636 !important',
            borderRadius: '20px',
            textAlign: 'center',
            fontSize: '18px',
          },
          '& .modal_header_wrapper': {
            justifyContent: 'center !important',
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
            gap: '10px',
          },
          // close icon CSS
          '& .modal_header_close_icon': {
            fontSize: '36px',
            color: '#277134 !important',
            position: 'absolute',
            right: '20px',
            cursor: 'pointer',
          },
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontSize: '20px',
          color: '#e69636',
          fontFamily: 'Rubik-Bold !important',
          color: '#277134 !important',
          userSelect: 'none',
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          '& .modal_main_content': {
            display: 'flex',
            gap: '10px',
            alignItems: 'center',
            '@media (max-width: 992px)': {
              flexDirection: 'column',
            },
          },
          '& .file_info_wrapper': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'start',
            gap: '10px',
            '& .file_info': {
              display: 'flex',
              alignItems: 'center',
              '& label': {
                whiteSpace: 'nowrap',
                fontWeight: 'bold',
              },
              '& span': {
                wordBreak: 'break-all',
              },
            },
          },
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          justifyContent: 'center !important',
        },
      },
    },
  },
});
